<div class="error">
  <img
    class="error__image"
    alt="ilustração de imagem não existente"
    src="../../../assets/imgs/errors-pages/error-banner.png"/>
  <div class="error__container">
    <h3 class="error__container__title">Sessão expirada</h3>
    <div class="error__container__text-container">
      <span class="error__container__text-container__text">A sua sessão foi encerrada automaticamente pela aplicação 
        para garantir sua segurança e para aumentar a disponibilidade do serviço.</span>
      <span class="error__container__text-container__text">
        <a class="error__container__text-container__text__link" [href]="portalUrl">Fazer login novamente</a>
      </span>
    </div>
  </div>
</div>
